import React, { useEffect, useState } from "react";
import PlusIcon from "../../assets/icons/plus";
import StatCard from "../Common/StatCard";
import UsersIcon from "../../assets/icons/users";
import LogIcon from "../../assets/icons/log";
import NoteIcon from "../../assets/icons/note";
import EmployeeTable from "../Common/EmployeeTable";
import api from "../../setupMiddleware";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import { Link } from "react-router-dom";
import Popup from "../Common/Popup";
import { hasPermission, isAdmin } from "../../Utils/auth";

const AllEmployee = () => {
  const loading = useApiLoader();
  const [empData, setEmpData] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [apiErrorOpen, setApiErrorOpen] = useState(false);
  // const [userSummary, setUserSummary] = useState({});

  const designationOptions = [
    { label: "All Designations", value: "" },
    ...(designationData?.map((des) => ({
      label: des.title,
      value: des.title,
    })) || []),
  ];

  const getAllUser = async () => {
    api.get("/api/employee-list").then((res) => {
      if (res && res.status === 200) {
        setEmpData(res.data?.employees);
      }
    });
  };

  const getAllDesignations = async () => {
    api.get("/api/designations").then((res) => {
      if (res && res.status === 200) {
        setDesignationData(res.data);
      }
    });
  };

  // const getUserSummary = async () => {
  //   try {
  //     api.get("/api/employees-summary").then((res) => {
  //       if (res && res.status === 200) {
  //         setUserSummary(res.data?.data);
  //       }
  //     });
  //   } catch (error) {
  //     console.log(error.res.data.message);
  //   }
  // };

  const handleStatusToggle = (action, userId) => {
    try {
      api
        .post(`/api/user-status/${userId}`, {
          status: action === "Disable" ? 0 : 1,
        })
        .then((res) => {
          if (res && res.status === 200) {
            window.location.reload();
          }
        });
    } catch (error) {
      setApiErrorOpen(true);
    }
  };

  useEffect(() => {
    getAllUser();
    getAllDesignations();
    // getUserSummary();
  }, []);

  // const stats = [
  //   {
  //     title: "Total Employee",
  //     value: userSummary?.total ? userSummary.total : 0,
  //     Icon: UsersIcon,
  //   },
  //   {
  //     title: "Present Today",
  //     value: userSummary?.present_today ? userSummary.present_today : 0,
  //     Icon: NoteIcon,
  //   },
  //   {
  //     title: "Employee On Leave",
  //     value: userSummary?.on_leave ? userSummary.on_leave : 0,
  //     Icon: LogIcon,
  //   },
  //   {
  //     title: "Absent Today",
  //     value: userSummary?.absent ? userSummary.absent : 0,
  //     Icon: NoteIcon,
  //   },
  // ];

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            All Employee
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Employee Details
          </span>
        </p>

        {/* Right Button */}
        {(isAdmin() || hasPermission("add_employees")) && (
          <div className="flex">
            <Link
              to="/add-employee"
              className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
            >
              <PlusIcon iconClass="w-4 h-4" color="#ffffff" />
              Add New Employee
            </Link>
          </div>
        )}
      </div>
      {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full mx-auto px-4 py-3">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div> */}
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                All Employees
              </p>
            </div>
            <EmployeeTable
              data={empData}
              designationOptions={designationOptions}
              handleDisableEnable={handleStatusToggle}
            />
          </div>
        </div>
      </div>
      <Popup
        isOpen={apiErrorOpen}
        onClose={() => setApiErrorOpen(false)}
        title="Error"
      >
        <div className="flex flex-col gap-6 mt-[30px] mb-[30px]">
          <div className="flex flex-col gap-2">
            <p className="text-sm text-[#142b70]/80 text-left">
              Something went wrong! Please try again later.
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={() => setApiErrorOpen(false)}
            className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
          >
            Ok
          </button>
        </div>
      </Popup>
    </>
  );
};

export default AllEmployee;
